<template>
  <div class="source">
    <div class="inspire-title">{{ $t('assist.inspirationSource') }}</div>
    <div class="header">
      <div class="header-main">
        <span class="header-content">{{ sourceInfo.paperTitle }}</span>
        <span class="header-caption">{{ $t('assist.journal') }}</span>
      </div>
      <img
        v-if="sourceInfo.rdPaperId"
        @click="goRp(sourceInfo.rdPaperId)"
        src="@/common/image/assist/rp.svg"
        alt=""
      />
    </div>
    <div class="body">
      <div
        class="bd-item"
        style="margin-top: 30px"
        v-if="sourceInfo.authors.length > 0"
      >
        <div :class="lang === 'CN' ? 'bd-title-cn' : 'bd-title-en'">
          {{ $t('assist.author') }}
        </div>
        <div class="bd-content">
          {{ sourceInfo.authors.join(', ').replaceAll('.', '') }}
        </div>
      </div>
      <div
        class="bd-item"
        v-if="sourceInfo.journalInfo['IF'] || sourceInfo.journalInfo.name"
      >
        <div :class="lang === 'CN' ? 'bd-title-cn' : 'bd-title-en'">
          {{ $t('assist.publishedBy') }}
        </div>
        <div class="bd-content pb-by">
          {{ sourceInfo.journalInfo.name ? sourceInfo.journalInfo.name : '' }}
          <span v-if="sourceInfo.journalInfo['IF']"
            >(IF :
            {{
              sourceInfo.journalInfo['IF'] ? sourceInfo.journalInfo['IF'] : ''
            }})</span
          >
        </div>
      </div>
      <div class="bd-item">
        <div
          class="pb-year-tl"
          :class="lang === 'CN' ? 'bd-title-cn' : 'bd-title-en'"
        >
          {{ $t('assist.year') }}
        </div>
        <div class="bd-content pb-year" v-if="sourceInfo.publishedYear">
          {{ sourceInfo.publishedYear }}
        </div>
      </div>
      <div class="bd-item" v-if="sourceInfo.numCitesAll">
        <div :class="lang === 'CN' ? 'bd-title-cn' : 'bd-title-en'">
          {{ $t('assist.citations') }}
        </div>
        <div class="bd-content citation">{{ sourceInfo.numCitesAll }}</div>
      </div>
      <div class="bd-item bd-abstract" style="">
        <div :class="lang === 'CN' ? 'bd-title-cn' : 'bd-title-en'">
          {{ $t('assist.abstract') }}
        </div>
        <div>
          <div :class="!isAbsDialog ? 'bd-abs-content' : 'bd-abs-content2'">
            <!-- <label class="bd-abs-btn" @click="expandAbstract">
            <el-tooltip
              effect="light"
              placement="bottom-start"
              :visible-arrow="false"
              :content="
                isAbsDialog ? $t('assist.packUp') : $t('assist.showMore')
              "
            >
              <img
                v-if="isAbsDialog"
                src="@/common/image/assist/up-arrow.svg"
                alt=""
              />
              <img v-else src="@/common/image/assist/down-arrow.svg" alt="" />
            </el-tooltip>
          </label> -->
            <!-- <span class="bd-abs-detail">
           
          </span> -->
            {{ sourceInfo.abstractString }}
          </div>
          <div class="more" @click="expandAbstract">
            {{ isAbsDialog ? $t('assist.packUp') : $t('assist.showMore') }}
          </div>
        </div>
      </div>
      <div class="bd-item bd-dialog">
        <div class="bd-title">{{ $t('assist.inspirationParagraph') }}</div>
        <div class="dialog-content" ref="dialogRef" style="height: auto">
          <div style="font-weight: 600; padding: 10px 0px; font-size: 16px">
            {{
              sourceInfo.origin
                ? sourceInfo.origin.slice(0, 1).toUpperCase() +
                  sourceInfo.origin.slice(1).toLowerCase()
                : 'Discussion'
            }}
          </div>
          <div
            class="bd-abstract"
            style="border-bottom: 0px; padding-bottom: 10px"
          >
            <div
              :class="!isExpDialog ? 'bd-abs-content' : 'bd-abs-content2'"
              v-html="sourceInfo.topicParagraph"
            ></div>
            <div class="more" @click="expandDialog">
              {{ isExpDialog ? $t('assist.packUp') : $t('assist.showMore') }}
            </div>
          </div>
        </div>
        <el-divider />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { sourceInfo } from '@/api/assist'
import { defineComponent, onMounted, PropType, ref } from 'vue'
import { getLang } from '@/hooks/lang'

export default defineComponent({
  props: {
    sourceInfo: {
      type: Object as PropType<sourceInfo>,
      required: false,
      default: () => ({}),
    },
  },
  setup(props) {
    const dialogRef = ref<HTMLDivElement>()
    const isExpDialog = ref(false)
    const isAbsDialog = ref(false)
    const lang = getLang()

    const expandDialog = () => {
      isExpDialog.value = !isExpDialog.value
    }
    const expandAbstract = () => {
      isAbsDialog.value = !isAbsDialog.value
    }

    const goRp = (rdPaperId: string) => {
      window.open(`https://readpaper.com/paper/${rdPaperId}`, '_blank')
    }

    onMounted(() => {
      if (props.sourceInfo.topicParagraph.split(' ').length < 150) {
        isExpDialog.value = false
        ;(dialogRef.value as any).style.height = 'auto'
      }
    })
    return {
      dialogRef,
      expandDialog,
      isExpDialog,
      isAbsDialog,
      expandAbstract,
      goRp,
      lang,
    }
  },
  methods: {},
})
</script>

<style lang="less" scoped>
.source {
  .body {
    margin-left: 15px;
    .bd-item {
      font-size: 15px;
      display: flex;
      margin-left: 15px;
      margin-top: 10px;
      .bd-title-cn {
        width: 80px;
        font-weight: 600;
        color: #6b727f;
      }
      .bd-title-en {
        width: 105px;
        font-weight: 600;
        color: #6b727f;
      }
      .bd-title {
        font-weight: 600;
        color: #6b727f;
      }
      .bd-content {
        width: 668px;
        color: #444444;
      }
    }
    .bd-abstract {
      border-bottom: 1px solid #e5e5e5;
      padding-bottom: 40px;
      .bd-abs-content,
      .bd-abs-content2 {
        width: 665px;
        line-height: 24px;
        color: #444444;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 20;
      }
      .bd-abs-content {
        -webkit-line-clamp: 3;
      }
      .bd-abs-content::before,
      .bd-abs-content2::before {
        content: '';
        float: right;
        height: 100%;
        margin-bottom: -20px;
      }
      /*
      .bd-abs-btn {
        float: right;
        clear: both;
        margin-right: 8px;
        padding-left: 40px;
        color: #f00;
        cursor: pointer;
      }
      .bd-abs-detail {
        line-height: 22px;
        color: #444444;
      }
      */

      .more {
        color: #0ca1bd;
        background: #e9f0fa;
        border-radius: 1px;
        padding: 0 4px;
        display: inline-block;
        cursor: pointer;
        margin-top: 16px;
      }
    }
    .bd-abstract::before {
      content: '';
      float: right;
      height: 100%;
      margin-bottom: -20px;
    }
    .bd-dialog {
      margin-top: 30px;
      display: block;
      .dialog-content {
        width: 750px;
        height: 285px;
        background: #f5f7fa;
        margin-top: 10px;
        padding: 15px 30px 0px;
        font-size: 15px;
        line-height: 25px;
        overflow: hidden;
        transition: all 3s;
      }
      .dialog-expand {
        width: 750px;
        height: 40px;
        line-height: 30px;
        text-align: right;
        background: #f5f7fa;
        padding-right: 25px;
        .dialog-expand-lf {
          float: left;
          margin-left: 30px;
        }
        .dialog-expand-rt {
          float: right;
          cursor: pointer;
        }
      }
      .el-divider {
        margin-left: -15px;
        margin-top: 40px;
        width: 780px;
        background: 0;
        border-top: 1px solid #e5e5e5;
      }
    }
  }
}
.source {
  .header {
    display: flex;
    justify-content: space-between;
    margin-left: 30px;
    margin-top: 10px;
    img {
      cursor: pointer;
    }
    .header-main {
      color: #444444;
      margin-top: 10px;
      margin-right: 20px;
      .header-caption {
        font-weight: 700;
        font-size: 11px;
        color: #9c9fa6;
        border: 1px solid #9c9fa6;
        border-radius: 5px;
        padding: 0px 3px;
        height: 18px;
        line-height: 16px;
        margin-left: 5px;
        display: inline-block;
      }
      .header-content {
        font-weight: 600;
        font-size: 18px;
        line-height: 25px;
      }
    }
  }
  .inspire-title {
    font-size: 18px;
    font-weight: 600;
    margin-top: 30px;
    border-left: 3px solid #0ca1bd;
    padding-left: 8px;
    color: #444444;
  }
}
.mobile-viewport {
  .source {
    margin-right: 15px;
  }
  .source .header {
    margin-left: 15px;
  }
  .source .header img {
    width: 75px;
  }
  .source .inspire-title {
    font-size: 17px;
  }
  .source .header .header-main .header-content {
    font-size: 16px;
  }
  .source .body .bd-item {
    margin-left: 0px;
    flex-wrap: wrap;
  }
  .bd-abstract .bd-abs-content,
  .source .body .bd-abstract .bd-abs-content,
  .source .body .bd-dialog .dialog-content,
  .source .body .bd-dialog .dialog-expand,
  .source .body .bd-dialog .el-divider,
  .source .body .bd-item .bd-content {
    width: auto;
  }
  .source .body .bd-item .bd-title-en,
  .source .body .bd-item .bd-title-cn,
  .source .body .bd-item .pb-year,
  .source .body .bd-item .pb-by,
  .source .body .bd-item .citation {
    height: 35px;
    line-height: 35px;
  }
  .source .body .bd-item .pb-year-tl {
    width: 70px;
  }
}
</style>

<style>
/*
.popper-eval .eval-bd {
  font-size: 12px;
}
.popper-eval .eval-bd .eval-bd-title {
  font-weight: 600;
  color: #444444;
  height: 20px;
  line-height: 20px;
}
.popper-eval .eval-bd .eval-bd-main {
  font-weight: 600;
  height: 20px;
  line-height: 20px;
}*/
</style>
